module.exports = __webpack_public_path__ + "img/home-1.df85c07d.svg";